import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export var deleteFolderRes;
export const deleteFolderTodo = createAsyncThunk('deleteFolder', async (id) => {
    let user_id = JSON.parse(localStorage.getItem('user_data'))

    try {
        const res = await axios({

            method: "post",
            url: process.env.REACT_APP_API_URL + 'library/delete_folder',
            data: {
                "user_id": user_id.vemp_code,
                "user_role": user_id.vrole_name,
                "folder_id": id,
                "device_token": user_id.vdevice_token
            },
            headers: { "Content-Type": "application/json", "Authorization": 'Bearer ' + user_id.access_token }
        })
        return deleteFolderRes = res.data
    } catch (error) {
        return deleteFolderRes = error.response.data
    }
})